module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"popup":{"title":"Decided not to sponsor?","description":"If you choose not to proceed with this candidate, you can archive their profile. This action can be reversed later if you change your mind"}}}')
  delete Component.options._Ctor
}
